import { MerchantTerminalContractType } from "Infrastructure/Api/Api";
import { z } from "zod";

export const contractSchema = z.object({
  publicID: z.string(),
  type: z.enum(MerchantTerminalContractType),
  merchantPublicID: z.string(),
  ucbTerminalContractDetail: z.object({ gprsCount: z.number() }).nullish(),
  comgateTerminalContractDetail: z
    .object({
      currencies: z.string().min(1),
      tariff: z.string().nullish(),
    })
    .nullish(),
});
